import { baseInMemoryFilterCompilers, createInMemoryFilterCompiler } from "./InMemoryFilter";
export const memberWithRegistrationsBlobInMemoryFilterCompilers = {
    ...baseInMemoryFilterCompilers,
    age: createInMemoryFilterCompiler('details.defaultAge'),
    gender: createInMemoryFilterCompiler('details.gender')
};
//# sourceMappingURL=inMemoryFilterDefinitions.js.map